export default  [
    '顺丰速运',
    '京东物流',
    '京东快运',
    '申通快递',
    '圆通速递',
    '韵达快递',
    '德邦快递',
    '德邦物流',
    '中通快递',
    '中通快运',
    '邮政电商标快',
    '邮政标准快递',
    '极兔速递',
    '百世快运',
    '菜鸟速递',
    '优速',
    '安能快运',
    '跨越速运',
    'D速快递',
    '顺心捷达',
    '其它',
    '送货上门',  
]
